import React, { useCallback, useState } from 'react';
import './index.less';
import { PlusOutlined } from '@ant-design/icons';
import { Modal,Upload, Image } from 'antd';
import type { GetProp, UploadFile, UploadProps } from 'antd';
import { getServiceVal } from '@/utils/cookies';
import { deleteFile, uploadFile } from '@/api/questions';
import { BaseResponseType } from '@/types/message';
import { UploadFileSize } from '@/types/base';
import useUpload from '@/hooks/useUpload';
interface UploadImageProps extends UploadFileSize {
  // Define your props here
  tipsMessage?: string;
  types?: string[];
  accept?:string
  fileRegex?: RegExp;
  open: boolean;
  onCancel: () => void;
  onOk?: (data: any) => void;
}
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
const getBase64 = (file: FileType): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });


  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>上传图片</div>
    </button>
  );
const prefix = 'Upload';
const UploadImage: React.FC<UploadImageProps> = (props) => {
  const {open,onCancel,
    fileRegex=/^image\/(?:png|jpeg|jpg|gif)/,
    accept='image/png,image/jpeg,image/jpg,image/gif',
    tipsMessage='支持 PNG, JPEG, JPG,GIF，单张图片大小不超过500KB，总大小不超过 5MB',
    singleSizeLimit=500,
    totalSizeLimit=1024*5,
    onOk,
    totalSize=0
  }=props;
  console.log('UploadImage render');
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const {
    fileList,
    setFileList,
    handleChange,
    uploadFileHandle
  }=useUpload({
    fileRegex: fileRegex,
    singleSizeLimit,
    uploadFileAction:uploadFile
  })
  
  const fileTotalSize=totalSize + Math.round(fileList.reduce((pre,cur:any)=>pre+cur.size,0)/1024);//已上传的图片总大小
  const isUploadBtn= (fileTotalSize >= totalSizeLimit);//是否显示 上传按钮
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };
  /**
   * 上传前
   * @param file 
   * @returns 
   */
  const beforeUpload=(file:any)=>{
    console.log('beforeUpload',file,fileTotalSize,file.size,totalSizeLimit*1024);
    if(!fileRegex.test(file.type)){
      window.message.warning(`请上传正确格式的图片`);
      return false
    }
    if(file.size>singleSizeLimit*1024){
      window.message.error(`单张图片大小不能超过${singleSizeLimit}KB`);
      return false
    }
    if(fileTotalSize*1024+file.size>totalSizeLimit*1024){
        window.message.error(`图片总大小不能超过${totalSizeLimit/1024}MB`);
        return false
      }
    return true
  }
  /**
   * 退出弹窗
   */
  const closeModal=()=>{
    if(fileList.length>0){
      let ids=fileList[0].fileId;
      fileList.forEach((item:any,index:number)=>{
        if(index>0){
          ids+=','+item.fileId
        }
      })
     ids&& deleteFile(ids)
    }
    setFileList([]);
    onCancel();
  }
  const okHandle=()=>{
    console.log('okHandle',fileList);
    if(fileList.length==0){
      window.message.warning('请上传图片');
      return
    }
    if(fileList.some((item:any)=>item.status!=='done')) return;
    onOk && onOk([...fileList]);
    setFileList([]);
    onCancel();
  }
  /**
   * 图片删除处理
   * @param file 
   */
  const onRemoveHandle=useCallback((file:any)=>{
    console.log('onRemoveHandle',file);
    deleteFile(file.fileId)
  },[])
  return (
    <>
      <Modal open={open} 
          centered
          onCancel={closeModal}
          onOk={okHandle}
          className='upload-modal'
        >
          <div className={`upload-modal-content`} style={{maxHeight:'500px',overflow:'auto'}} onClick={(e) => e.stopPropagation()}>
            <div className={`upload-modal-content-title`}>插入图片</div>
            <Upload
              accept={accept}
              customRequest={uploadFileHandle}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onChange={handleChange}
              onRemove={onRemoveHandle}
              beforeUpload={beforeUpload}
            >
              {uploadButton}
            </Upload>
            <div className="upload-modal-content-tips">
              <div>当前已上传图片总大小:{fileTotalSize}KB</div>
            </div>
            <div className="upload-modal-content-tips">
              <div>{tipsMessage}</div>
            </div>
            {previewImage && (
              <Image
                className='upload-modal-content-img'
                wrapperStyle={{ display: 'none' }}
                preview={{
                  maskClassName:'asdas',
                  visible: previewOpen,
                  onVisibleChange: (visible) => setPreviewOpen(visible),
                  afterOpenChange: (visible) => !visible && setPreviewImage(''),
                }}
                src={previewImage}
              />
            )}
          </div>
        </Modal>
    </>
  );
};

export default UploadImage;
